/*
 * Created by Ali Simsek on 5/14/20, 2:02 PM
 * Copyright (c) 2020 Carla Car Rental, Inc. All rights reserved.
 * Last modified 5/14/20, 10:58 AM
 */

import round from 'lodash/round'
import floor from 'lodash/floor'

const ccRegex = {
  // either start with the numbers 51-55 or with the numbers 2221-2720. all have 16 digits
  mastercard: /^(?:5[1-5]|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/,
  // start with a 4. New cards have 16 digits. Old cards have 13.
  visa: /^4[0-9]?/,
  // start with 34 or 37 and have 15 digits.
  amex: /^3[47]/,
  // begin with 300-305, 36-38. All have 14 digits
  diners: /^3(?:0[0-5]|[68])/,
  // begin with 6011 or 65. All have 16 digits.
  discover: /^6(?:011|5)/,
  // begin with 2131 or 1800 have 15 digits. begin with 35 have 16 digits.
  jcb: /^(?:2131|1800|35)/
}

const ccMask = {
  default: '9999 9999 9999 9999',
  amex: '9999 999999 99999',
  diners: '9999 9999 9999 99'
}

const ccIcons = {
  mastercard: 'card-master',
  visa: 'card-visa',
  amex: 'card-amex',
  diners: 'card-diners',
  discover: 'card-discover',
  jcb: 'card-jcb',
  unknown: 'card-unknown'
}

const currencySymbols = {
  AED: 'AED',
  ANG: 'ANG',
  ARS: 'ARS',
  AUD: 'AUD',
  BRL: 'BRL',
  BSD: 'BSD',
  CAD: 'CAD',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CZK: 'CZK',
  DKK: 'DKK',
  EUR: 'EUR',
  FJD: 'FJD',
  GBP: 'GBP',
  GHS: 'GHS',
  GTQ: 'GTQ',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  ISK: 'ISK',
  JMD: 'JMD',
  JPY: 'JPY',
  KRW: 'KRW',
  LKR: 'LKR',
  MAD: 'MAD',
  MMK: 'MMK',
  MXN: 'MXN',
  MYR: 'MYR',
  NOK: 'NOK',
  NZD: 'NZD',
  PAB: 'PAB',
  PEN: 'PEN',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  SEK: 'SEK',
  SGD: 'SGD',
  THB: 'THB',
  TND: 'TND',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  USD: 'USD',
  VEF: 'VEF',
  VND: 'VND',
  XAF: 'XAF',
  XCD: 'XCD',
  XPF: 'XPF',
  ZAR: 'ZAR'
}

const money = {
  /**
   * get mask for react-text-mask
   * @returns {array}
   */
  getCCMask(ccType) {
    return ccMask[ccType] || ccMask.default
  },

  /**
   * get react fontawesome icon for cc
   * @returns {Component}
   */
  getCCIcon(ccType) {
    return ccIcons[ccType] || 'card-unknown'
  },

  /**
   * get credit card type
   * @returns {string|null}
   */
  getCCType(number) {
    for (let ccType in ccRegex) {
      if (ccRegex[ccType].test(number)) return ccType
    }
    return null
  },

  /**
   * @param amount {string|number} 123.456
   * @param currency {string} USD|TRY...
   * @returns {string} $123.45
   */
  formatMoney(amount, currency) {
    const amountStr = round(amount, 2)
    let currencyStr = ''
    if (currency) currencyStr = currencySymbols[currency] || currency
    return `${currencyStr}${amountStr}`
  },
  /**
   * @param amount {string|number} 123.456
   * @param currency {string} USD|TRY...
   * @returns {string} $123
   */
  formatMoneyFloored(amount, currency) {
    const amountStr = floor(amount)
    let currencyStr = ''
    if (currency) currencyStr = currencySymbols[currency] || currency
    return `${currencyStr}${amountStr}`
  },

  formatCurrency(currency) {
    return `${currencySymbols[currency]}`
  }
}

export default money
